module.exports = __webpack_public_path__ + "img/img3.80a47528.jpg";